<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login login-4 login-signin-on d-flex flex-row-fluid"
      id="kt_login"
    >
      <div
        class="
          d-flex
          flex-center flex-row-fluid
          bgi-size-cover bgi-position-top bgi-no-repeat
        "
        style="background-image: url('media/bg/bg-3.jpg')"
      >
        <div
          class="login-form text-center p-7 position-relative overflow-hidden"
        >
          <div class="d-flex flex-center mb-15">
            <a href="#">
              <img src="media/logos/Logo-X.png" class="max-h-120px" alt="" />
            </a>
          </div>
          <div class="login-signin">
            <div class="mb-20">
              <h3>Sign In To Dashboard</h3>
              <div class="text-muted font-weight-bold">
                Enter your credential to login:
              </div>
            </div>
            <form
              class="form"
              id="kt_login_signin_form"
              @submit.stop.prevent="onSubmitLogin()"
            >
              <div class="form-group mb-5">
                <input
                  class="form-control h-auto form-control-solid py-4 px-8"
                  type="text"
                  placeholder="Email"
                  name="username"
                  autocomplete="off"
                  :value="form.username"
                />
              </div>
              <div class="form-group mb-5">
                <input
                  class="form-control h-auto form-control-solid py-4 px-8"
                  type="password"
                  placeholder="Password"
                  name="password"
                  :value="form.password"
                />
              </div>
              <button
                ref="kt_login_signin_submit"
                class="
                  btn btn-primary btn-block
                  font-weight-bolder font-size-h6
                  px-15
                  py-4
                  my-3
                  mr-3
                "
              >
                Sign In
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped src="@/assets/css/login-4.css"></style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/store/auth.module";
import Swal from "sweetalert2";
var qs = require("qs");

export default {
  name: "login-1",
  data() {
    return {
      state: "signin",
      // Remove this dummy login info
      form: {
        username: "varx",
        password: "varx",
      },
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser"]),

    backgroundImage() {
      return (
        process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg"
      );
    },
  },
  mounted() {
    const signin_form = KTUtil.getById("kt_login_signin_form");

    this.fv = formValidation(signin_form, {
      fields: {
        username: {
          validators: {
            notEmpty: {
              message: "Username is required",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });
  },
  methods: {
    showForm(form) {
      this.state = form;
      var form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name),
        "animate__animated animate__backInUp"
      );
    },

    onSubmitLogin() {
      this.fv.validate();

      this.fv.on("core.form.valid", () => {
        var username = this.form.username;
        var password = this.form.password;

        // clear existing errors
        this.$store.dispatch(LOGOUT);

        // set spinner to submit button
        const submitButton = this.$refs["kt_login_signin_submit"];
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        let data = qs.stringify({ username, password });

        // dummy delay
        setTimeout(() => {
          // send login request
          this.$store
            .dispatch(LOGIN, data)
            // go to which page after successfully login
            .then(() => this.$router.push({ name: "dashboard" }))
            .catch(() => {});

          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        }, 2000);
      });

      this.fv.on("core.form.invalid", () => {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      });
    },
  },
};
</script>
